var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#008330;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8,16c4.4,0,8-3.6,8-8c0-4.4-3.6-8-8-8C3.6,0,0,3.6,0,8C0,12.4,3.6,16,8,16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.4,5c-0.2-0.2-0.4-0.2-0.7-0.2c-0.2,0-0.4,0.2-0.5,0.3L6.8,9.7L5.2,8.1C5.1,7.9,4.9,7.8,4.7,7.8 C4.4,7.8,4.2,7.8,4,8C3.9,8.1,3.7,8.4,3.7,8.6c0,0.2,0.1,0.5,0.2,0.6l2.3,2.3c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0.1 c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1 c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0,0l5-5.3C12.8,5.8,12.7,5.3,12.4,5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.4babb0805ec0b33c7e52a6c8f7e29f7b.svg";
export { ForwardRef as ReactComponent };